import React from 'react';
import BaseTypography from 'src/components/Text/BaseTypography';

const BUTTON_CLASSES = [
  'appearance-none',
  'border',
  'border-solid',
  'border-gray-100',
  'text-left',
  'flex-1',
  'outline-none',
  'px-3',
  'py-2',
  'rounded',
  'transition',
  'hover:bg-gray-100',
  'hover:cursor-pointer',
].join(' ');

export function ActiveState() {
  const [activeTab, setActiveTab] = React.useState<
    'totalClients' | 'activeClients' | 'activeSubscriptions'
  >('totalClients');

  return (
    <>
      <header className="pb-6 flex flex-row items-center gap-3">
        <button
          className={`${BUTTON_CLASSES} ${
            activeTab === 'totalClients' ? 'bg-gray-50' : 'bg-transparent'
          }`}
          onClick={() => setActiveTab('totalClients')}
        >
          <BaseTypography className="text-nowrap" fontType="15Regular">
            Total clients
          </BaseTypography>
          <BaseTypography fontType="15Medium">10</BaseTypography>
        </button>

        <button
          className={`${BUTTON_CLASSES} ${
            activeTab === 'activeClients' ? 'bg-gray-50' : 'bg-transparent'
          }`}
          onClick={() => setActiveTab('activeClients')}
        >
          <BaseTypography className="text-nowrap" fontType="15Regular">
            Active clients
          </BaseTypography>
          <BaseTypography fontType="15Medium">4</BaseTypography>
        </button>

        <button
          className={`${BUTTON_CLASSES} ${
            activeTab === 'activeSubscriptions'
              ? 'bg-gray-50'
              : 'bg-transparent'
          }`}
          onClick={() => setActiveTab('activeSubscriptions')}
        >
          <BaseTypography className="text-nowrap" fontType="15Regular">
            Active subscriptions
          </BaseTypography>
          <BaseTypography fontType="15Medium">2</BaseTypography>
        </button>
      </header>

      {/* TODO: Brand green */}
      <div className="text-green-600">TK...</div>
    </>
  );
}
